import React from "react";

import moment from "moment";

type CartTimerProps = {
  secondsLeft: number;
  containerClassName?: string;
  timeClassName?: string;
  showText?: boolean;
  format?: string;
};

export default function CartTimer({
  secondsLeft,
  containerClassName,
  timeClassName,
  showText = true,
  format = "mm:ss",
}: CartTimerProps): JSX.Element {
  return (
    <>
      {secondsLeft > 0 && (
        <div className={containerClassName}>
          {showText && "Cart saved for: "}
          <span className={timeClassName}>
            {moment(new Date(1970, 0, 1).setSeconds(secondsLeft)).format(
              format
            )}
          </span>
        </div>
      )}
    </>
  );
}
